<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <!-- <li>
            <router-link :to="{path:'/dashboard'}">Dashboard</router-link>
          </li> -->
        </ul>
      </nav>
      <div class="copyright">
        Copyright &copy; {{year}} 
        <a :href="website">{{adminTitle}}</a>.
        All rights reserved.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  computed: {
    website() {
      return process.env.VUE_APP_WEBSITE;
    },
    adminTitle() {
      return process.env.VUE_APP_ADMINTITLE
    }
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
</style>
